import React, { useState, useEffect, useCallback } from "react";
import './../Maintenance/Maintenance.css';
import {CreateButton, CreateSearchBarWithPlaceHolder} from '../CommonObjects';
import {SetAuditTrail, SetAuditTrailBulk} from './../Reports/AuditTrailReportEmployeeSetup';
import axios from 'axios';
import {CreateTable} from '../ManageTable';
import {token, domain} from '../Security';
import loadingSpinner from './../../assets/loading.gif';
// icon
import SearchIcon from '@mui/icons-material/Search';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function PayrollPeriod({user, isHideSideMenu}) {
    var header = [
        "ID",
        "Pay Type",
        "Date From",
        "Date To",
        "Status",
        "Is Posted Time Keeping?",
        "Is Posted Payroll?",
        "",
    ]
    var accessor = [
        "id",
        "payTypeDescription",
        "dateFrom",
        "dateTo",
        "isActive",
        "timeKeepingFlg",
        "payrollFlg",
        "manage"
    ]

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [payrollPeriod, setPayrollPeriod] = useState([]);
    const [originalPayrollPeriod, setOriginalPayrollPeriod] = useState([]);
     // Retrieve
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("----Select filter----");
    // Add
    const [showAddForm, setShowAddForm] = useState(false);
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [payTypeId, setPayTypeId] = useState("");
    const [timeKeepingFlg, setTimeKeepingFlg] = useState(false);
    const [payrollFlg, setPayrollFlg] = useState(false);
    const [isActive, setIsActive] = useState(false);
    // Update
    const [showEditForm, setShowEditForm] = useState(false);
    const [editById, setEditById] = useState("");
    const [editDateFrom, setEditDateFrom] = useState("");
    const [editDateTo, setEditDateTo] = useState("");
    const [editPayTypeId, setEditPayTypeId] = useState("");
    const [editTimeKeepingFlg, setEditTimeKeepingFlg] = useState(false);
    const [editPayrollFlg, setEditPayrollFlg] = useState(false);
    const [editIsActive, setEditIsActive] = useState("");
    //Old
    const [oldEditDateFrom, setOldEditDateFrom] = useState("");
    const [oldEditDateTo, setOldEditDateTo] = useState("");
    const [oldEditIsActive, setOldEditIsActive] = useState("");

    const [filterPayTypeId, setFilterPayTypeId] = useState("");
    const [filterStatus, setFilterStatus] = useState("");
    const [filterYear, setFilterYear] = useState("");
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end
    
    const apiUrl =  domain + "/api/PayrollPeriod";

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await axios.get(apiUrl, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setPayrollPeriod(response.data); // Set the response data to the state
            setOriginalPayrollPeriod(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl]);

    useEffect(() => {
        fetchData();
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("----Select filter----")
                break;
            case 1:
                setSearchPlaceholder("Search by payroll period id")
                break;
            default:
                setSearchPlaceholder("----Select filter----")
                break;
        }
    }, [filterDataIndex, fetchData]);

    useEffect(() => {
        let filteredData = originalPayrollPeriod;
    
        if (filterPayTypeId !== "") {
            filteredData = filteredData.filter(i => i.payTypeId?.toString() === filterPayTypeId.toString());
        }
    
        if (filterYear) {
            filteredData = filteredData.filter(i => new Date(i.dateFrom).getFullYear().toString() === filterYear || new Date(i.dateTo).getFullYear().toString() === filterYear);
        }

        if (filterStatus) {
            const status = filterStatus === "Active";
            filteredData = filteredData.filter(i => i.isActive === status);
        }
    
        setPayrollPeriod(filteredData);
        setFilterData(filteredData);
    }, [filterPayTypeId, filterYear, filterStatus, originalPayrollPeriod]);

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                return;
            case 1:
                res = filterData.filter((f) =>
                f.id.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                break;
        }

        setPayrollPeriod(res);
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        const data = {
            dateFrom: dateFrom,
            dateTo: dateTo,
            payTypeId: payTypeId,
            isActive: isActive,
            timeKeepingFlg: timeKeepingFlg,
            payrollFlg: payrollFlg
        };

        try {
            setLoadingRequest(true);
            const response = await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            setShowAddForm(false); // Hide the add form
            await SetAuditTrail({
                setupArea: "Payroll Period", 
                actionTaken: "add", 
                field: "Add", 
                newValue: `${response.data.name}`, 
                oldValue: "-", 
                dateSaved: new Date(), 
                savedById: user.id
            });

            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Data added successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
            
            // Reload table data and reset form fields
            setDateFrom("");
            setDateTo("");
            setPayTypeId("");
            setIsActive(false);
            setTimeKeepingFlg(false);
            setPayrollFlg(false);
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowAddForm(false);
    };
    const handleUpdate = async (event) => {
        event.preventDefault();

        const data = {
            dateFrom: editDateFrom,
            dateTo: editDateTo,
            payTypeId: editPayTypeId,
            isActive: editIsActive,
            timeKeepingFlg: editTimeKeepingFlg,
            payrollFlg: editPayrollFlg
        };

        console.log('Final bulkData:', JSON.stringify(data, null, 2));

        try {
            setLoadingRequest(true);
            await axios.put(apiUrl + `/${editById}`, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            setShowEditForm(false);
            let auditInfo = [];

            if(data.dateFrom !== oldEditDateFrom){
                auditInfo.push({
                    setupArea: "Date From",
                    actionTaken: "update",
                    field: "Date From",
                    newValue: `${data.dateFrom}`,
                    oldValue: `${oldEditDateFrom}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            if(data.dateTo !== oldEditDateTo){
                auditInfo.push({
                    setupArea: "Date To",
                    actionTaken: "update",
                    field: "Date To",
                    newValue: `${data.dateTo}`,
                    oldValue: `${oldEditDateTo}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            if(data.isActive !== oldEditIsActive){
                auditInfo.push({
                    setupArea: "Payroll Period",
                    actionTaken: "update",
                    field: "Is Active?",
                    newValue: `${data.isActive ? "Active" : "InActive"}`,
                    oldValue: `${oldEditIsActive ? "Active" : "InActive"}`,
                    dateSaved: new Date(),
                    savedById: user.id,
                });
            }

            await SetAuditTrailBulk({data: auditInfo});

            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Data updated successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);

            // Reload table data and reset form fields
            setEditDateFrom("");
            setEditDateTo("");
            setEditPayTypeId("");
            setEditIsActive(false);
            setEditTimeKeepingFlg(false);
            setEditPayrollFlg(false);
            setEditById("");
        } catch (error) {
            console.error('There was a problem updating data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }

        setShowEditForm(false);
    };

    const addHandleClick = () => {
        setShowAddForm(true);
    };
    const editHandleClick = (data) => {
        setEditById(data.id);
        setEditDateFrom(data.dateFrom);
        setEditDateTo(data.dateTo);
        setEditPayTypeId(data.payTypeId);
        setEditTimeKeepingFlg(data.timeKeepingFlg);
        setEditPayrollFlg(data.payrollFlg);
        setEditIsActive(data.isActive);
        setOldEditDateFrom(data.dateFrom);
        setOldEditDateTo(data.dateTo);
        setOldEditIsActive(data.isActive);
        setShowEditForm(true);
    };
    const closeAddHandleClick = () => {
        setShowAddForm(false);
    };
    const closeEditHandleClick = () => {
        setShowEditForm(false);
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="MainteInfo">
                        <div className="mainteHeader">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Payroll >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Payroll Period"}</span>
                            </div>
                            <h3>Payroll Period</h3>
                        </div>
                        <div className="mainte-body">
                            <div style={{display: "none"}}>
                                {Filter(setFilterDataIndex)}
                                <div className="mainte-body-top row">
                                    {CreateSearchBarWithPlaceHolder("", "mainte-search row", "mainte-search-icon", "mainte-search-input", (e)=>handleFilter(e.target.value), searchPlaceholder, SearchIcon)}
                                    <div className="mainte-addBtn row">
                                        {CreateButton("", "add row", addHandleClick, "ADD", NoteAddIcon)}
                                    </div>
                                </div>
                            </div>
                            <div className='filters-payroll'>
                                <span>Filter</span>
                                <div className="payroll-item-holder info-item-holder row" style={{justifyContent:"space-evenly", padding: "0 10px 20px 10px"}}>
                                    <div className="filter-item-payroll popUp-item info-item column">
                                        <div className="info-item-label">Pay Type</div>
                                        <div className="info-item-input">
                                            <PayTypeIdSelectFilter payTypeId={filterPayTypeId} setPayTypeId={setFilterPayTypeId}/>
                                        </div>
                                        <span style={{
                                            visibility: "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up Pay Type first
                                        </span>
                                    </div>
                                    <div className="filter-item-payroll popUp-item info-item column">
                                        <div className="info-item-label">Year</div>
                                        <div className="info-item-input">
                                            <YearSelect year={filterYear} setYear={setFilterYear} payrollPeriod={payrollPeriod}/>
                                        </div>
                                        <span style={{
                                            visibility: "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up Pay Type first
                                        </span>
                                    </div>
                                    <div className="filter-item-payroll popUp-item info-item column">
                                        <div className="info-item-label">Status</div>
                                        <div className="info-item-input">
                                            <StatusSelect status={filterStatus} setStatus={setFilterStatus}/>
                                        </div>
                                        <span style={{
                                            visibility: "hidden",
                                            color:"#ff6565", 
                                            fontSize:"12px"}}>Please fill up Pay Type first
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="mainte-body-top row">
                                <div className="mainte-addBtn row" style={{justifyContent: "start"}}>
                                    {CreateButton("", "add row", addHandleClick, "ADD", NoteAddIcon)}
                                </div>
                            </div>
                            <div className="maintenance-table container">
                                <CreateTable
                                    dataList={payrollPeriod}
                                    dataHeader={header}
                                    dataAccessor={accessor}
                                    editHandleClick={editHandleClick}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddForm  isOpen={showAddForm} 
                    onClose={closeAddHandleClick}
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    payTypeId={payTypeId}
                    isActive={isActive}
                    timeKeepingFlg={timeKeepingFlg}
                    payrollFlg={payrollFlg}
                    setDateFrom={setDateFrom}
                    setDateTo={setDateTo}
                    setPayTypeId={setPayTypeId}
                    setIsActive={setIsActive}
                    setTimeKeepingFlg={setTimeKeepingFlg}
                    setPayrollFlg={setPayrollFlg}
                    handleSubmit={handleSubmit}
            >
            </AddForm>
            <EditForm  isOpen={showEditForm} 
                    onClose={closeEditHandleClick}
                    editDateFrom={editDateFrom}
                    editDateTo={editDateTo}
                    editPayTypeId={editPayTypeId}
                    editIsActive={editIsActive}
                    editTimeKeepingFlg={editTimeKeepingFlg}
                    editPayrollFlg={editPayrollFlg}
                    setEditDateFrom={setEditDateFrom}
                    setEditDateTo={setEditDateTo}
                    setEditPayTypeId={setEditPayTypeId}
                    setEditIsActive={setEditIsActive}
                    setEditTimeKeepingFlg={setEditTimeKeepingFlg}
                    setEditPayrollFlg={setEditPayrollFlg}
                    handleUpdate={handleUpdate}
            >
            </EditForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest || loading ? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function AddForm({isOpen, 
    onClose,
    dateFrom,
    dateTo,
    payTypeId,
    isActive, 
    timeKeepingFlg, 
    payrollFlg, 
    setDateFrom,
    setDateTo, 
    setPayTypeId, 
    setIsActive, 
    setTimeKeepingFlg, 
    setPayrollFlg, 
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!dateFrom || !dateTo || !payTypeId){
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setDateFrom("");
        setDateTo("");
        setPayTypeId("");
        setIsActive(false);
        setTimeKeepingFlg(false);
        setPayrollFlg(false);
        setErrorState(false);
    };

    const handleIsActiveChange = (event) => {
        setIsActive(event.target.checked);
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add Payroll Period</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Pay Type</div>
                            <div className="info-item-input">
                                <PayTypeIdSelect payTypeId={payTypeId} setPayTypeId={setPayTypeId}/>
                            </div>
                            <span style={{
                                        visibility: !payTypeId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date From</div>
                            <div className="info-item-input">
                                <DateTimeInput date={dateFrom} setDate={setDateFrom}/>
                            </div>
                            <span style={{
                                        visibility: !dateFrom && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date To</div>
                            <div className="info-item-input">
                                <DateTimeInput date={dateTo} setDate={setDateTo} />
                            </div>
                            <span style={{
                                        visibility: !dateTo && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is Active?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={isActive}
                                onChange={(e)=>handleIsActiveChange(e)}/>
                            </div>
                        </div>
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is Posted Time Keeping?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={timeKeepingFlg}
                                onChange={(e)=>setTimeKeepingFlg(e.target.checked)}/>
                            </div>
                        </div>
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is Posted Payroll?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={payrollFlg}
                                onChange={(e)=>setPayrollFlg(e.target.checked)}/>
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
                )}
            </div>
        </>
    );
}
function EditForm({isOpen, 
    onClose, 
    editDateFrom,
    editDateTo,
    editPayTypeId,
    editIsActive, 
    editTimeKeepingFlg, 
    editPayrollFlg, 
    setEditDateFrom,
    setEditDateTo,  
    setEditPayTypeId,  
    setEditIsActive, 
    setEditTimeKeepingFlg, 
    setEditPayrollFlg, 
    handleUpdate})
{
    const [errorState, setErrorState] = useState(false);

    const submit = (e) =>{
        if(!editDateFrom || !editDateTo || !editPayTypeId){
            setErrorState(true);
            return;
        }
        handleUpdate(e);
        setErrorState(false);
    };

    const handleClose = () => {
        onClose();
        setErrorState(false);
    };

    const handleIsActiveChange = (event) => {
        setEditIsActive(event.target.checked);
    };

    console.log("editTimeKeepingFlg", editTimeKeepingFlg);
    console.log("editPayrollFlg", editPayrollFlg);

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update Payroll Period</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Pay Type</div>
                            <div className="info-item-input">
                                <PayTypeIdSelect payTypeId={editPayTypeId} setPayTypeId={setEditPayTypeId}/>
                            </div>
                            <span style={{
                                        visibility: !editPayTypeId && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date From</div>
                            <div className="info-item-input">
                                <DateTimeInput date={editDateFrom} setDate={setEditDateFrom}/>
                            </div>
                            <span style={{
                                        visibility: !editDateFrom && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Date To</div>
                            <div className="info-item-input">
                                <DateTimeInput date={editDateTo} setDate={setEditDateTo}/>
                            </div>
                            <span style={{
                                        visibility: !editDateTo && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is Active?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={editIsActive}
                                onChange={(e)=>handleIsActiveChange(e)}/>
                            </div>
                        </div>
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is Posted Time Keeping?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={editTimeKeepingFlg}
                                onChange={(e)=>setEditTimeKeepingFlg(e.target.checked)}/>
                            </div>
                        </div>
                        <div className="popUp-item info-item row" style={{alignItems:"center"}}>
                            <div className="info-item-label" style={{paddingRight:"10px"}}>Is Posted Payroll?</div>
                            <div className="info-item-input">
                                <input type="checkbox" 
                                id="isActive-checkbox" 
                                className="checkbox" 
                                name="" 
                                checked={editPayrollFlg}
                                onChange={(e)=>setEditPayrollFlg(e.target.checked)}/>
                            </div>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                UPDATE
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function Filter(setFilterDataIndex){
    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "PayrollPeriodId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="PayrollPeriodId">Payroll Period Id</option>
            </select>
        </div>
    );
};
function DateTimeInput({date, setDate}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setDate(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        if(date !== undefined && date !== ""){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [date]);

    let formattedDate = "";

    if(date){
        formattedDate = date.split('T')[0];
    }

    return (
        <div>
            <input
            type="date"
            id={"datetime-"}
            name="datetime"
            value={formattedDate}
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}
function PayTypeIdSelect({payTypeId, setPayTypeId}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setIsSelected(true);
        setPayTypeId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/PayType/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if(payTypeId !== "" && payTypeId !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [payTypeId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={payTypeId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose pay type</option>
            {data.map((payTypeId) => ( 
                SetPayTypeId(payTypeId)
            ))}
            </select>
        </div>
    );
};
function PayTypeIdSelectFilter({payTypeId, setPayTypeId}){
    const handleSelectChange = (event) => {
        setPayTypeId(event.target.value);
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/PayType/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={payTypeId || ""} onChange={handleSelectChange}style={{ color: "rgb(104, 104, 104)" }}>
            <option value="">All</option>
            {data.map((payTypeId) => ( 
                SetPayTypeId(payTypeId)
            ))}
            </select>
        </div>
    );
};
function SetPayTypeId(payTypeId){
    return(
        <option value={payTypeId.id}>{
            payTypeId.description}
        </option>
    )
    
}
function YearSelect({ year, setYear, payrollPeriod }) {
    const years = [...new Set(payrollPeriod.map(p => new Date(p.dateFrom).getFullYear()))]
        .sort((a, b) => b - a); // Sort from latest to earliest

    const handleSelectChange = (event) => {
        setYear(event.target.value);
    };

    return (
        <div>
            <select 
                id="employee-select-PagibigReport" 
                value={year} 
                onChange={handleSelectChange} 
                style={{ color: "rgb(104, 104, 104)" }}
            >
                <option value="">All</option>
                {years.map((y) => (
                    <option key={y} value={y}>{y}</option>
                ))}
            </select>
        </div>
    );
};
function StatusSelect({ status, setStatus }) {
    const handleSelectChange = (event) => {
        setStatus(event.target.value);
    };

    return (
        <div>
            <select 
                id="employee-select-PagibigReport" 
                value={status} 
                onChange={handleSelectChange} 
                style={{ color: "rgb(104, 104, 104)" }}
            >
                <option value="">All</option>
                <option value="Active">Active</option>
                <option value="InActive">InActive</option>
            </select>
        </div>
    );
};

export default PayrollPeriod
